export const dataCouvert = [
        {
            "foto": require("../../../images/cardapio/001.jpg"),
            "nome": "Peixe Caverna",
            "descriçãoPt": 'Deliciosos bolinhos de peixe com queijo muçarela acompanhados de exclusiva geleia de pimenta.',
            "descriçãoIng": 'Cheese-filled croquettes accompanied by pepper jam.',
            "descriçãoEsp": 'Croquetas de pescado qo rellenas con queso.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$29,80'
        },
        {
            "foto": require("../../../images/cardapio/002.jpg"),
            "nome": "Dadinho de Tapioca",
            "descriçãoPt": 'Farinha de tapioca, queijo parmesão, ovos e leite.',
            "descriçãoIng": 'Tapioca flour, parmesan cheese, eggs and milk.',
            "descriçãoEsp": 'Harina de tapioca, queso parmesano, huevos y leche.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$29,80'

        },
        {
            "foto": require("../../../images/cardapio/003.jpg"),
            "nome": "Bolinho Pantaneiro",
            "descriçãoPt": 'Arroz, carne de sol, queijo parmesão e cheiro verde.',
            "descriçãoIng": 'Rice, jerked beef, parmesan cheese, parsley and chives.',
            "descriçãoEsp": 'Arroz, carne desidratada, queso',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$29,80'

        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Tesampo",
            "descriçãoPt": 'A Lingüiça fininha, preparada e elaborada pelo proprietário seguindo uma receita tradicional de sua família. Acompanha mandioca e farofa. OPÇÕES: Bovina – Boi | Ovina – Cordeiro.',
            "descriçãoIng": 'A thin sausage, prepared and developed by the owner following a traditional family recipe. Served with cassava and farofa, traditional Brazilian dish prepared with wholegrain cassava flour, eggs, onions and bacon Options: Beef or Lamb.',
            "descriçãoEsp": 'Salchicha finamente elaborada, acompañada de yuca y farofa. Una receta tradicional de familia, preparada con dedicación por el dueño.Sabores disponibles:  carne de res o cordero.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$65,80'

        },
    ]

export const dataSaladas = [
        {
            "foto": require("../../../images/cardapio/004.jpg"),
            "nome": "Salada Simples",
            "descriçãoPt": 'Alface, tomate e cebola.',
            "descriçãoIng": 'Lettuce, tomato and onion.',
            "descriçãoEsp": 'Lechuga, tomate y cebola.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$21,80'
        },
        {
            "foto": require("../../../images/cardapio/005.jpg"),
            "nome": "Salada Gaúcha",
            "descriçãoPt": 'Alface, tomate, bacon, palmito, batata palha, azeitonas e molho da casa.',
            "descriçãoIng": 'Lettuce, tomato, bacon, palm heart, shoestring potatoes, olives and house dressing.',
            "descriçãoEsp": 'Lechuga, tomate, bacon, palmito, patata paja, aceitunas y salsa de la casa.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$53,80'
        },
        {
            "foto": require("../../../images/cardapio/006.jpg"),
            "nome": "Salada Tropical",
            "descriçãoPt": 'Alface, tomate, palmito, cebola, azeitona, kani-kama e molho da casa.',
            "descriçãoIng": 'Lettuce, tomato, palm heart, onion, olives, kani-kama and house dressing.',
            "descriçãoEsp": 'Lechuga, tomate, palmito, cebolla, aceituna, kani-kama y salsa de la casa.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$53,80'
        },
        {
            "foto": require("../../../images/cardapio/007.jpg"),
            "nome": "Salada Individual",
            "descriçãoPt": 'Alface, tomate e cebola.',
            "descriçãoIng": 'Lettuce, tomato and onion.',
            "descriçãoEsp": 'Lechuga, tomate y cebolla.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$12,80'
        },
    ]

export const dataPiraputanga = [
        {
            "foto": require("../../../images/cardapio/008.jpg"),
            "nome": "Piraputanga Frita",
            "descriçãoPt": 'Piraputanga frita servida inteira, acompanhado de arroz, batata frita e pirão.',
            "descriçãoIng": 'Breaded Piraputanga fish, served with rice, french fries and pirão (pure of manioc flour and fish).',
            "descriçãoEsp": 'Piraputanga rebozada, servida con arroz, papas fritas y pirão (pure de harina de yuca y pescado).',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$177,80'
        },
        {
            "foto": require("../../../images/cardapio/009.jpg"),
            "nome": "Piraputanga Grelhada",
            "descriçãoPt": 'Piraputanga grelhada, servida com arroz, batata e pirão.',
            "descriçãoIng": 'Grilled Piraputanga fish, served with rice, potato and pirão (pure of manioc flour and fish).',
            "descriçãoEsp": 'Piraputanga a la plancha, servida con arroz, papas y pirão (pure de harina de yuca y pescado).',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$182,80'
        },
    ]

export const dataPintado = [
        {
            "foto": require("../../../images/cardapio/010.jpg"),
            "nome": "Pintado ao Urucum",
            "descriçãoPt": 'File de Pintado a dorê coberto com molho especial de urucum, queijo gratinado, servido com arroz e farofa de banana.',
            "descriçãoIng": 'Pintado fish fillet covered with a Brazilian annatto sauce au gratin with cheese, served with rice, and banana crumbs. ',
            "descriçãoEsp": '/ Filet de Pintado encubierto con salsa de urucum, servido con arroz y farofa de plátano.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$168,80'
        },
        {
            "foto": require("../../../images/cardapio/011.jpg"),
            "nome": "Pintado na Telha ao Molho de Camarão",
            "descriçãoPt": 'Ensopado de Pintado na telha de barro com camarão, cebola, tomate, pimentão, leite de coco, azeite de dendê, creme de leite, arroz e farofa de banana.',
            "descriçãoIng": 'Pintado fish stew with shrimps sauce, onion, tomato, sweet pepper, coconut milk, dendê (palm) oil, heavy cream, served with rice.',
            "descriçãoEsp": 'Guisado de Pintado en la teja con gambas, cebolla, tomate, pimiento dulce, leche de coco, aceite de dendê (palma) y crema de leche, servido con arroz.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$206,80'
        },
        {
            "foto": require("../../../images/cardapio/012.jpg"),
            "nome": "Pintado à Parmegiana",
            "descriçãoPt": 'File de Pintado à milanesa, molho de tomate, queijo gratinado, servido com arroz e batata frita.',
            "descriçãoIng": 'Breaded fish with tomato sauce au gratin, served with rice and French fries.',
            "descriçãoEsp": 'Parmegiana de pescado con salsa de tomate, gratinado con queso, servido con arroz e papas fritas.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$163,80'
        },
        {
            "foto": require("../../../images/cardapio/013.jpg"),
            "nome": "Pintado Grelhado com Alcaparras",
            "descriçãoPt": 'Servido com arroz, batata saute e farofa de banana.',
            "descriçãoIng": 'Grilled Pintado fish fillet with capers, served with rice, sauteed potatoes and banana crumbs.',
            "descriçãoEsp": 'filet de pescado a la plancha, servido con arroz, papas saute y farofa de plátano.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$163,80'
        },
        {
            "foto": require("../../../images/cardapio/014.jpg"),
            "nome": "Pintado à Milanesa",
            "descriçãoPt": 'Servido com arroz, batata frita e pirão.',
            "descriçãoIng": 'Breaded fish, served with rice, french fries and pirão (pure of manioc flour and fish).',
            "descriçãoEsp": 'Milanesa de pescado servido con arroz, papas fritas y pirão (pure de harina de yuca y pescado).',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$125,80'
        },
        {
            "foto": require("../../../images/cardapio/015.jpg"),
            "nome": "Pintado ao Imperador",
            "descriçãoPt": 'Cortes especiais de Pintado, grelhado com amêndoas levemente torradas e champignon na manteiga, servido com arroz e batata saute.',
            "descriçãoIng": 'Grilled fish fillet, lightly toasted almonds and mushrooms in butter, served with rice and sauteed potatoes.',
            "descriçãoEsp": 'Filet de pescado a la plancha con almendras tostadas y champifiones en mantequilla, servido con arroz y papas saute.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$190,80'
        },
        {
            "foto": require("../../../images/cardapio/016.jpg"),
            "nome": "Moqueca de Pintado",
            "descriçãoPt": 'Ensopado com tomate, cebola, pimentão, leite de coco, azeite de dendê, arroz e farofa de banana.',
            "descriçãoIng": 'Brazilian fish stew with onions, tomatoes, palm tree oil and coconut milk, served with rice and banana crumbs.',
            "descriçãoEsp": 'Guisado de pescado, cebolla, tomate, pimiento dulce, leche de coco, aceite de dendê (palma), servido con arroz y farofa de plátano.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$179,80'
        },
        
    ]

export const dataTilapia = [
        {
            "foto": require("../../../images/cardapio/017.jpg"),
            "nome": "Tilápia à Milanesa",
            "descriçãoPt": 'Filé de Tilápia à milanesa servido com arroz e batata frita.',
            "descriçãoIng": 'Breaded fish fillet, served with rice and French fries.',
            "descriçãoEsp": 'Filet de Tilápia rebozado, servido con arroz y papas fritas.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$119,80'
        },
        {
            "foto": require("../../../images/cardapio/018.jpg"),
            "nome": "Tilápia Rincão",
            "descriçãoPt": 'File de Tilápia à milanesa, servido com arroz e pirão.',
            "descriçãoIng": 'Breaded fish fillet, served with rice and pirão (pure of manioc flour and fish).',
            "descriçãoEsp": 'Filet de Tilápia rebozado, servido con arroz y pirão (pure de harina de yuca y pescado).',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$158,80'
        },
        {
            "foto": require("../../../images/cardapio/019.jpg"),
            "nome": "Casal Bonito",
            "descriçãoPt": 'File de Tilápia à milanesa e costela de Pacu fritas, servido com arroz e pirão.',
            "descriçãoIng": 'Breaded Tilapia fish fillet and Pacu fish ribs, served with rice and pirão (pure of manioc flour and fish).',
            "descriçãoEsp": 'Filet de Tilápia (pescado) rebozado y costillas de Pacu (pescado), servido con arroz y pirão (pure de harina de yuca y pescado).',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$158,80'
        }
        
    ]

export const dataPacu = [
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Pacu do Pescador",
            "descriçãoPt": 'Pacu grelhado com cebola e tomate picados, gratinado com queijo, servido com arroz, batata saute e farofa de banana.',
            "descriçãoIng": 'Grilled skin-on Pacu fish with chopped onion and tomato, covered with cheese au gratin, served with rice, sautéed potatoes and banana crumbs.',
            "descriçãoEsp": 'Banda de Pacu a la plancha con cebolia y tomate picados, cubierto con queso gratinado, servido con arroz, papas saute y farofa de plátano.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$165,80'
        },
        {
            "foto": require("../../../images/cardapio/021.jpg"),
            "nome": "Pacu Grelhado",
            "descriçãoPt": 'Servido com arroz, farofa de banana, legumes no vapor e pirão.',
            "descriçãoIng": 'Grilled Pocu fish, served with rice, banana crumbs, steamed vegetables and pirão (pure of manioc flour and fish).',
            "descriçãoEsp": 'Pacu a la plancha, servido con arroz, farofa de plátano, legumbres al vapor y pirão (pure de harina de yuca y pescado).',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$160,80'
        },
        {
            "foto": require("../../../images/cardapio/022.jpg"),
            "nome": "Pacu Frito",
            "descriçãoPt": 'Servido com arroz, batata frita, farofa de banana e pirão.',
            "descriçãoIng": 'Breaded fish ribs, served with rice, french fries, banana crumbs and pirão (pure of manioc flour and fish).',
            "descriçãoEsp": 'Costillas de Pacu rebozada, servida con arroz, papas fritas, farofa de plátano y pirão (pure de harina de yuca y pescado)',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$128,80'
        },
        
    ]

export const dataCarneBovina = [
                {
            "foto": require("../../../images/cardapio/024.jpg"),
            "nome": "Bife Ancho Cowboy",
            "descriçãoPt": 'Grelhado e acebolado, servido com 2 ovos fritos, arroz, batata frita e farofa de alho.',
            "descriçãoIng": 'Grilled sirloin steak with saute onions, served with 2 sunny side eggs, rice, French fries and garlic crumbs.',
            "descriçãoEsp": 'Croquetas de pescado qo rellenas con queso.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$113,80'
        },
        {
            "foto": require("../../../images/cardapio/025.jpg"),
            "nome": "Família Pintada",
            "descriçãoPt": 'Bife ancho grelhado e acebolado, servido com 3 ovos fritos, arroz e batata frita.',
            "descriçãoIng": 'Grilled sirloin steak with saute onions, served with 3 sunny side eggs, rice and French fries.',
            "descriçãoEsp": 'Bife de chorizo a la plancha con cebola, servido con 3 huevos fritos, arroz y papas fritas.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$170,80'
        },
        {
            "foto": require("../../../images/cardapio/026.jpg"),
            "nome": "File Mignon ao Molho Miellé",
            "descriçãoPt": 'Medalhas de mignon grelhado, servido com molho agridoce de mel, champignon e especiarias. Acompanha arroz e batata frita.',
            "descriçãoIng": 'Grilled tenderloin medallion served with bittersweet sauce of honey mushroom and spices, accompanies rice and French fries.',
            "descriçãoEsp": 'Medallas de lomo a la plancha, servido con salsa agridulce de miel, champifion y especiarias. Acompaiia arroz y papas fritas.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$164,80'
        },
        {
            "foto": require("../../../images/cardapio/027.jpg"),
            "nome": "Filé Mignon à Parmegiana",
            "descriçãoPt": 'Filé mignon à milanesa, molho de tomate, queijo gratinado, servido com arroz e batata frita.',
            "descriçãoIng": 'Breaded tenderloin fillet, covered by tomato sauce and cheese au gratin, served with rice and French fries.',
            "descriçãoEsp": 'Parmegiana de lomo con salsa de tomate, queso gratinado, servido con arroz y papas fritas.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$154,80'
        },
        {
            "foto": require("../../../images/cardapio/028.jpg"),
            "nome": "Filé Mignon Grelhado",
            "descriçãoPt": 'Medalhas de mignon grelhado, arroz e batata dourada.',
            "descriçãoIng": 'Grilled tenderloin medallion, served with rice and golden potatoes.',
            "descriçãoEsp": 'Medallas de lomo a la plancha, servido con arroz y papas doradas.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$138,80'
        },
        {
            "foto": require("../../../images/cardapio/029.jpg"),
            "nome": "Filé Mignon Grelhado ao Molho Provolone",
            "descriçãoPt": 'Medalhas de mignon grelhado, queijo provolone, servido com arroz e batata frita.',
            "descriçãoIng": 'Grilled tenderloin medallion, provolone cheese, served with rice and French fries.',
            "descriçãoEsp": 'Medallas de lomo a la plancha, queso provolone, servido con arroz y papas frita.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$164,80'
        },
        
    ]

export const dataAdicionais = [
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Arroz",
            "descIng": 'Rice',
            "price": 'R$9,80'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Pirão",
            "descIng": 'Pure of manioc flour and fish',
            "descEsp": 'Pure de harina de yuca y pescado',
            "price": 'R$14,80'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Batata Saute",
            "descIng": 'Sauteed potatoes',
            "descEsp": 'Papas soute',
            "price": 'R$18,80'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Feijão",
            "descIng": 'Brown beans',
            "descEsp": 'Frijoles',
            "price": 'R$9,80'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Legumes no Vapor",
            "descIng": 'Steamed vegetables',
            "descEsp": 'Legumbres al vapor',
            "price": 'R$24,80'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Ovo Frito",
            "descIng": 'Sunny side egg',
            "descEsp": 'Huevo frito',
            "price": 'R$5,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Farofa de Alho",
            "descIng": 'Garlic crumbs',
            "descEsp": 'Farofa de ajo',
            "price": 'R$9,80'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Farofa de Banana",
            "descIng": 'Banana crumbs',
            "descEsp": 'Farofa de plátano',
            "price": 'R$11,80'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Embalagem",
            "descIng": 'Conteiner to take away',
            "descEsp": 'Embalaje',
            "price": 'R$5,00'
        },
    ]

export const dataParaUmaPessoa = [
        {
            "foto": require("../../../images/cardapio/030_foto_em_breve.jpg"),
            "nome": "Pintado à Milanesa",
            "descriçãoPt": 'Servido com arroz e batata frita.',
            "descriçãoIng": 'Breaded Pintado Fish Fillet, served with rice and french fries',
            "descriçãoEsp": 'Milanesa de Pintado (pescado), servido con arroz y papas fritas.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$75,80'
        },
        {
            "foto": require("../../../images/cardapio/031.jpg"),
            "nome": "Pintado ao Urucum",
            "descriçãoPt": 'File de Pintado a dorê coberto com molho especial de urucum, queijo gratinado, servido com arroz, batata dourada.',
            "descriçãoIng": 'Pintado fish fillet cover with a Brazilian annaito sauce au gratin with cheese, served with rice and golden potato.',
            "descriçãoEsp": 'Filet de Pintado (pescado) encubierto con salsa de urucu, servido con arroz y patata de oro.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$91,80'
        },
        {
            "foto": require("../../../images/cardapio/032.jpg"),
            "nome": "Frango Grelhado",
            "descriçãoPt": 'Filé de frango grelhado, servido com arroz e batata frita.',
            "descriçãoIng": 'Grilled fillet of chicken breast, served with rice and French fries.',
            "descriçãoEsp": 'Filet de pechuga de pollo a ta plancha, servido con arroz y papas fritas.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$56,80'
        },
        {
            "foto": require("../../../images/cardapio/033_foto_em_breve.jpg"),
            "nome": "Bife Ancho Mimoso",
            "descriçãoPt": 'Grelhado, servido com arroz, batata frita e farofa de alho.',
            "descriçãoIng": 'Grilled sirloin steak, served with rice, French fries and garlic crumbs.',
            "descriçãoEsp": 'Bife de chorizo a la plancha, servido con arroz, papas fritas y farofa de ajo.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$62,80'
        },
        {
            "foto": require("../../../images/cardapio/034_foto_em_breve.jpg"),
            "nome": "Tilápia à Milanesa",
            "descriçãoPt": 'Filé de Tilápia à milanesa, servido com arroz e batata frita.',
            "descriçãoIng": 'Breaded Tilápia fish fillet, served with rice and French fries.',
            "descriçãoEsp": 'Filet de Tilápia (pescado) rebozado, servido con arroz y papas fritas.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$70,80'
        },
        {
            "foto": require("../../../images/cardapio/035.jpg"),
            "nome": "Pintado Fit",
            "descriçãoPt": 'Cortes especiais de pintado, grelhado com amêndoas levemente torradas e champignon no azeite, servido com batata doce.',
            "descriçãoIng": 'Grilled Pintado fish with lightly toasted almonds and mushrooms in butter, served with sweet potatoes.',
            "descriçãoEsp": 'Pintado (pescado) a la plancha, con almendras ligeramente tostadas y champifiones en mantequilla,servido con papas dulce.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$93,80'
        },
        {
            "foto": require("../../../images/cardapio/036.jpg"),
            "nome": "Moqueca Vegana",
            "descriçãoPt": 'Legumes salteados em azeite de oliva com molho de tomate, cebola, pimentão, leite de coco e banana da terra, servido com arroz.',
            "descriçãoIng": 'Sautéed vegetables with olive oil, with tomatoes sauce, onion, sweet pepper, coconut milk and banana, served with rice.',
            "descriçãoEsp": 'Legumbres salteados al aceite de olive, con salsa de tomate, cebolla, pimiento dulce, leche de coco y plátano, servido con arroz.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$50,80'
        },
        {
            "foto": require("../../../images/cardapio/037_foto_em_breve.jpg"),
            "nome": "Vegetariano",
            "descriçãoPt": 'Omelete, servido com arroz, alface, tomate e cebola.',
            "descriçãoIng": 'Omeleite, served with rice, lettuce, tomatoes and onion.',
            "descriçãoEsp": ' Tortilla, servida con arroz, lechuga, tomate ycebolla.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$42,80'
        },
        {
            "foto": require("../../../images/cardapio/038.jpg"),
            "nome": "Legumes ao Molho Provolone",
            "descriçãoPt": 'Legumes na manteiga com molho de queijo Provolone.',
            "descriçãoIng": 'Vegetables in butter with Provolone cheese sauce.',
            "descriçãoEsp": 'Legumbres en mantequilia con salsa de queso Provolone.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$46,80'
        },
        {
            "foto": require("../../../images/cardapio/039.jpg"),
            "nome": "Kids Carne",
            "descriçãoPt": 'Iscas de filé mignon grelhada, servido com arroz, batata frita e feijão.',
            "descriçãoIng": 'Grilled tenderloin stripes, served with rice, French fries and brown beans.',
            "descriçãoEsp": 'Tiritas de lomo de ternera a la plancha, servida con arroz, papas fritas y frijoles.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$35,80'
        },
        {
            "foto": require("../../../images/cardapio/039.jpg"),
            "nome": "Kids Frango",
            "descriçãoPt": 'Iscas de filé de frango grelhado, servido com arroz, batata frita e feijão.',
            "descriçãoIng": 'Grilled chicken stripes, served with rice, french fries and brown beans.',
            "descriçãoEsp": 'Tiritas de polo a la plancha, servida con arroz, papas fritas y frijoles.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$32,80'
        },
        {
            "foto": require("../../../images/cardapio/041.jpg"),
            "nome": "Kids Peixe",
            "descriçãoPt": 'Iscas de filé de tilápia à dorê, servido com arroz, batata frita e feijão.',
            "descriçãoIng": 'Breaded fish stripes, served with rice, French fries and brown beans.',
            "descriçãoEsp": 'Tiritas de Tilápia rebozado, servida con arroz, papas fritas y frijoles.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$35,80'
        },
        
    ]

export const dataPorcoes = [
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Piraputanga Safadinha (Peixe inteiro)",
            "descriçãoPt": '',
            "descriçãoIng": 'Breaded Piraputanga fish (the whole fish).',
            "descriçãoEsp": 'Piraputanga (pescado) frito entero.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$144,80'
        },
        {
            "foto": require("../../../images/cardapio/043_foto_em_breve.jpg"),
            "nome": "Isca de Tilápia",
            "descriçãoPt": '',
            "descriçãoIng": 'Breaded Tilapia fish strips.',
            "descriçãoEsp": 'Tiritas de filet de Tilápia (pescado).',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$89,80'
        },
        {
            "foto": require("../../../images/cardapio/044_foto_em_breve.jpg"),
            "nome": "Isca de Pintado",
            "descriçãoPt": '',
            "descriçãoIng": 'Breaded Pintado fish strips.',
            "descriçãoEsp": 'Tiritas de Pintado (pescado).',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$92,80'
        },
        {
            "foto": require("../../../images/cardapio/045.jpg"),
            "nome": "Batata Frita",
            "descriçãoPt": '',
            "descriçãoIng": 'French fries.',
            "descriçãoEsp": 'Papas fritas.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$38,80'
        },
        {
            "foto": require("../../../images/cardapio/046.jpg"),
            "nome": "Contra Filé Acebolado",
            "descriçãoPt": '',
            "descriçãoIng": 'Grilled sirloin steak with sautéed onions.',
            "descriçãoEsp": 'Bife de chorizo a la plancha con cebola.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$80,80'
        },
        {
            "foto": require("../../../images/cardapio/047.jpg"),
            "nome": "Pacu na Trilha",
            "descriçãoPt": '',
            "descriçãoIng": 'Breaded Pacu fish ribs.',
            "descriçãoEsp": 'Costilla de Pacu (pescado).',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$89,80'
        },
        {
            "foto": require("../../../images/cardapio/048.jpg"),
            "nome": "Jacaré Aperitivo (Dorê ou Grelhado)",
            "descriçãoPt": '100g',
            "descriçãoIng": 'Caiman strips (Breaded or Grilled).',
            "descriçãoEsp": 'Tiritas de caimán (Rebozado o a la plancha).',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$55,80'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Jacaré Porção (Dorê ou Grelhado)",
            "descriçãoPt": '300g',
            "descriçãoIng": 'Caiman strips (Breaded or Grilled).',
            "descriçãoEsp": 'Tiritas de caimán (Rebozado o a la plancha).',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$166,80'
        },
        {
            "foto": require("../../../images/cardapio/050.jpg"),
            "nome": "Mandioca Frita",
            "descriçãoPt": '',
            "descriçãoIng": 'Sticks of fried manioc.',
            "descriçãoEsp": 'Yuca frita.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$38,80'
        },
        {
            "foto": require("../../../images/cardapio/051_foto_em_breve.jpg"),
            "nome": "Filé Mignon Acebolado",
            "descriçãoPt": '',
            "descriçãoIng": 'Grilled tenderloin with sautéed onions.',
            "descriçãoEsp": 'Lomo de ternera a la plancha con cebolla.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$99,80'
        },
        {
            "foto": require("../../../images/cardapio/051_foto_em_breve.jpg"),
            "nome": "Molhos Adicionais",
            "descriçãoPt": '',
            "descriçãoIng": 'Extra Sauces.',
            "descriçãoEsp": 'Salsas Adicionales.',
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$3,00'
        },
        
    ]

export const dataBebidas = [
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Stella 600ml",
            "descIng": 'Cerveja',
            "descEsp": 'Beer | Cerveza',
            "price": 'R$22,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Spaten 600ml",
            "descIng": 'Cerveja',
            "descEsp": 'Beer | Cerveza',
            "price": 'R$21,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Original 600ml",
            "descIng": 'Cerveja',
            "descEsp": 'Beer | Cerveza',
            "price": 'R$21,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Brahma 600ml",
            "descIng": 'Cerveja',
            "descEsp": 'Beer | Cerveza',
            "price": 'R$18,50'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Corona Long Neck 330ml",
            "descIng": 'Cerveja',
            "descEsp": 'Beer | Cerveza',
            "price": 'R$16,50'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Stella Long Neck 330ml",
            "descIng": 'Cervaja',
            "descEsp": 'Beer | Cerveza',
            "price": 'R$15,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Budweiser Long Neck 330ml e Bud Zero",
            "descIng": 'Long neck and alcohol free beer',
            "descEsp": 'Cerveza long neck y sin alcohol',
            "price": 'R$15,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Energético",
            "descIng": 'Energy Drink',
            "descEsp": 'Energético',
            "price": 'R$20,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Refrigerante lata 350ml",
            "descIng": 'Soft Drink',
            "descEsp": 'Gaseosa',
            "price": 'R$8,88'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Água Tônica / Água Tônica zero",
            "descIng": 'Tonic water / Tonic Zero',
            "descEsp": '',
            "price": 'R$9,88'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Água Mineral com Gás",
            "descIng": 'Sparkling water',
            "descEsp": 'Con gás',
            "price": 'R$6,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Água Mineral sem Gás",
            "descIng": 'Still water',
            "descEsp": 'Sin gás',
            "price": 'R$6,00'
        },
        
    ]

export const dataSucos = [
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Laranja",
            "descIng": 'Orange',
            "descEsp": 'Naranja',
            "price": 'R$14,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Limão",
            "descIng": 'Lime',
            "descEsp": 'Limón',
            "price": 'R$14,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": " Morango",
            "descIng": 'Strawberry',
            "descEsp": 'Fresa',
            "price": 'R$16,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": " Abacaxi",
            "descIng": 'Pineapple',
            "descEsp": 'Pinã',
            "price": 'R$14,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": " Abacaxi com  Hortelã",
            "descIng": 'Pineapple with  Mint',
            "descEsp": 'Pinã con Menta',
            "price": 'R$14,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": " Maracujá",
            "descIng": 'Passion Fruit',
            "descEsp": '',
            "price": 'R$16,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Suco Misto",
            "descIng": 'Mix Juice',
            "descEsp": 'Jugo Misto',
            "price": 'R$18,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": " Adicional Leite Integral",
            "descIng": 'Milk',
            "descEsp": 'Leche',
            "price": 'R$4,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": " Adicional Leite Condensado",
            "descIng": 'Condensed Milk',
            "descEsp": 'Leche Condensada',
            "price": 'R$4,00'
        },
        
    ]

export const dataCoqueteis = [
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Caipirinha de Cachaça",
            "descriçãoPt": "Com limão: R$25,00\nCom polpa: R$31,00",
            "descriçãoIng": "With Lime: R$25,00\nWith fruit pulp: R$31,00",
            "descriçãoEsp": "Con Limón: R$25,00\nCon pulpa de fruta: R$31,00",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$25,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Caipiroska de Vodka Smirnoff",
            "descriçãoPt": 'Com limão: R$28,00\nCom polpa: R$34,00',
            "descriçãoIng": "With Lime: R$28,00\nWith fruit pulp: R$34,00",
            "descriçãoEsp": "Con Limón: R$28,00\nCon pulpa de fruta: R$34,00",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$28,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Caipiroska de Vodka Absolute",
            "descriçãoPt": 'Com limão: R$36,00\nCom polpa: R$40,00',
            "descriçãoIng": "With Lime: R$36,00\nWith fruit pulp: R$40,00",
            "descriçãoEsp": "Con Limón: R$36,00\nCon pulpa de fruta: R$40,00",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$36,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Caipiríssima de Rum",
            "descriçãoPt": 'Com limão: R$28,00\nCom polpa: R$32,00',
            "descriçãoIng": "With Lime: R$28,00\nWith fruit pulp: R$32,00",
            "descriçãoEsp": "Con Limón: R$28,00\nCon pulpa de fruta: R$32,00",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$28,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Saquerinha",
            "descriçãoPt": 'Com limão: R$28,00\nCom polpa: R$32,00',
            "descriçãoIng": "With Lime: R$28,00\nWith fruit pulp: R$32,00",
            "descriçãoEsp": "Con Limón: R$28,00\nCon pulpa de fruta: R$32,00",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$28,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Cozumel",
            "descriçãoPt": 'Limão, gelo, sal, long neck.\nCorona: R$28,00\nBudweiser: R$25,00',
            "descriçãoIng": "Lemon. salt, ice and long neck.",
            "descriçãoEsp": "Limón. sal, hielo y cuello largo",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$28,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Marguerita",
            "descriçãoPt": 'Tequila, curaçau blue, gelo e limão.',
            "descriçãoIng": "Tequila, blue curaçao, ice and lemon.",
            "descriçãoEsp": "Tequila, curaçao azul, hielo y limón.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$39,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Pinã Colada",
            "descriçãoPt": 'Abacaxi polpa, leite condensado, leite de coco, rum e gelo.',
            "descriçãoIng": "Pineapple pulp, condensed milk, coconut milk, rum and ice.",
            "descriçãoEsp": "Pulpa de piña, leche condensada, leche de coco, ron y hielo.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$39,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Gin Tônica",
            "descriçãoPt": 'Gin, gelo, limão ou laranja.',
            "descriçãoIng": "Gin, ice, lemon or orange.",
            "descriçãoEsp": "Ginebra, hielo, limón o naranja.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$32,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Gin Tropical",
            "descriçãoPt": 'Gin e red bull tropical, limão ou laranja.',
            "descriçãoIng": "Gin and tropical red bull, lemon or orange.",
            "descriçãoEsp": "Ginebra y red bull tropical, limón o naranja.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$36,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Negroni",
            "descriçãoPt": 'Campari, Aperol e Martini.',
            "descriçãoIng": "Campari, Aperol and Martini.",
            "descriçãoEsp": "Campari, Aperol y Martini.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$45,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Contreau Fizz",
            "descriçãoPt": 'Contreau, suco de limão e água com gás.',
            "descriçãoIng": "Contreau, lemon juice and sparkling water.",
            "descriçãoEsp": "Contreau, jugo de limón y agua con gas.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$41,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Lagoa Azul",
            "descriçãoPt": 'Vodka, curaçau blue, suco de limão e soda limonada.',
            "descriçãoIng": "Vodka, blue curaçao, lemon juice and lemonade soda.",
            "descriçãoEsp": "Vodka, curazao azul, jugo de limón y refresco de limonada.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$45,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Tequila Sun Rise",
            "descriçãoPt": 'Suco de laranja, tequila e groselha.',
            "descriçãoIng": "Orange juice, tequila and blackcurrant.",
            "descriçãoEsp": "Zumo de naranja, tequila y grosella negra.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$42,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Cuba Libre",
            "descriçãoPt": 'Rum, suco de limão e coca cola.',
            "descriçãoIng": "Rum, lemon juice and coca cola.",
            "descriçãoEsp": "Ron, zumo de limón y coca cola.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$30,00'
        },
    ]

export const dataDrinksSemAlcool = [
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Soda Italiana",
            "descriçãoPt": "Groselha, suco de limão e água com gás.",
            "descriçãoIng": "Gooseberry, lemon juice and sparkling water.",
            "descriçãoEsp": "Grosella, zumo de limón y agua con gas.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$29,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Limonada Suíça com Leite Condensado",
            "descriçãoPt": '',
            "descriçãoIng": "Swiss lemonade with condensed milk.",
            "descriçãoEsp": "Limonada suiza con leche condensada.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$22,00'
        },
    ]

export const dataBatidas = [
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Morango",
            "descriçãoPt": "Morango, leite condensado e vodka.",
            "descriçãoIng": "Strawberry, condensed milk and vodka.",
            "descriçãoEsp": "Fresa, leche condensada y vodka.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$36,00'
        },
        {
            "foto": require("../../../images/cardapio/049_foto_em_breve.jpg"),
            "nome": "Coco",
            "descriçãoPt": 'Leite de coco, leite condensado e vodka.',
            "descriçãoIng": "Coconut milk, condensed milk and vodka.",
            "descriçãoEsp": "Leche de coco, leche condensada y vodka.",
            
            "icon": require("../../../images/cardapio/2p.png"),
            "price": 'R$36,00'
        },
    ]

export const dataDoses = [
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Vodka Smirnoff",
            "price": 'R$14,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Vodka Absolute",
            "price": 'R$23,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Whisky 8 anos Importado",
            "price": 'R$27,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Whisky 12 anos Importado",
            "price": 'R$37,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Cachaça da casa",
            "price": 'R$7,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "CDB",
            "price": 'R$9,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Campari",
            "price": 'R$19,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Rum",
            "price": 'R$14,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Tequila",
            "price": 'R$30,50'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Gin",
            "price": 'R$21,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Aperol",
            "price": 'R$19,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Martini",
            "price": 'R$17,00'
        },
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Saquê",
            "price": 'R$9,90'
        },
    ]
    
export const dataCafes = [
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Café",
            "DescProdAlpha": "Espresso, curto, duplo, doppio e americano.",
            "price": 'R$7,50'
        },
    ]

export const dataSobremesas = [
        {
            "foto": require("../../../images/cardapio/foto_em_breve.jpg"),
            "nome": "Petit Gateau",
            "price": 'R$32,00'
        },
    ]

export const cardapioSections = [
    {
        name: "Couvert",
        id: "couvert",
        items: dataCouvert
    },
    {
        name: "Saladas",
        id: "saladas",
        items: dataSaladas
    },
    {   
        name: "Piraputanga",
        id: "piraputanga",
        items: dataPiraputanga
    },
    {
        name: "Pintado",
        id: "pintado",
        items: dataPintado
    },
    {
        name: "Tilápia",
        id: "tilapia",
        items: dataTilapia
    },
    {
        name: "Pacu",
        id: "pacu",
        items: dataPacu
    },
    {
        name: "Carne Bovina",
        id: "carne_bovina",
        items: dataCarneBovina
    },
    {
        name: "Adicionais",
        id: "adicionais",
        items: dataAdicionais
    },
    {
        name: "Para Uma Pessoa",
        id: "para_uma_pessoa",
        items: dataParaUmaPessoa
    },
    {
        name: "Poções",
        id: "porcoes",
        items: dataPorcoes
    },
    {
        name: "Bebidas",
        id: "bebidas",
        items: dataBebidas
    },
    {
        name: "Sucos",
        id: "sucos",
        items: dataSucos
    },
    {
        name: "Coquetéis",
        id: "coqueteis",
        items: dataCoqueteis
    },
    {
        name: "Drinks sem Álcool",
        id: "drinks_sem_alcool",
        items: dataDrinksSemAlcool
    },
    {
        name: "Batidas",
        id: "batidas",
        items: dataBatidas
    },
    {
        name: "Doses",
        id: "doses",
        items: dataDoses
    },
    {
        name: "Cafés",
        id: "cafes",
        items: dataCafes
    },
    {
        name: "Sobremesas",
        id: "sobremesas",
        items: dataSobremesas
    },
    
]